import { render, staticRenderFns } from "./RegisteredMobile.vue?vue&type=template&id=1f0d12b4&"
import script from "./RegisteredMobile.vue?vue&type=script&lang=js&"
export * from "./RegisteredMobile.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegisteredMobile.vue"
export default component.exports